import { useState, useCallback } from "react"
import { updateNotificationSettings } from "../api/notificationSettingsApi"

// Small mutation wrapper mirroring collections' useMutation: exposes
// { mutate, isPending } and rethrows a normalized error array.
export function useUpdateNotificationSettings() {
  const [isPending, setPending] = useState(false)

  const mutate = useCallback(async (settings, scope) => {
    setPending(true)
    try {
      return await updateNotificationSettings(settings, scope)
    } catch (err) {
      throw err.response?.data?.errors || [err.message || "Something went wrong"]
    } finally {
      setPending(false)
    }
  }, [])

  return { mutate, isPending }
}
